<template>
    <h2>Calls</h2>
</template>

<script>
    import firebase from 'firebase'
    import db from '@/firebase/init'
    export default {
        name: "Calls"
    }
</script>

<style scoped>

</style>
